/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/operators/not in.json`.

import type { OperatorDefinition } from '../../definition_types';

/**
 * The `NOT IN` operator allows testing whether a field or expression does *not* equal any element in a list of literals, fields or expressions.
 */
const definition: OperatorDefinition = {
  operator: 'not in',
  name: 'not_in',
  signatures: [
    {
      params: [
        {
          name: 'field',
          type: 'boolean',
          optional: false,
        },
        {
          name: 'inlist',
          type: 'boolean',
          optional: false,
        },
      ],
      variadic: true,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'cartesian_point',
          optional: false,
        },
        {
          name: 'inlist',
          type: 'cartesian_point',
          optional: false,
        },
      ],
      variadic: true,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'cartesian_shape',
          optional: false,
        },
        {
          name: 'inlist',
          type: 'cartesian_shape',
          optional: false,
        },
      ],
      variadic: true,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'date_range',
          optional: false,
        },
        {
          name: 'inlist',
          type: 'date_range',
          optional: false,
        },
      ],
      variadic: true,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'double',
          optional: false,
        },
        {
          name: 'inlist',
          type: 'double',
          optional: false,
        },
      ],
      variadic: true,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'double_range',
          optional: false,
        },
        {
          name: 'inlist',
          type: 'double_range',
          optional: false,
        },
      ],
      variadic: true,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'geo_point',
          optional: false,
        },
        {
          name: 'inlist',
          type: 'geo_point',
          optional: false,
        },
      ],
      variadic: true,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'geo_shape',
          optional: false,
        },
        {
          name: 'inlist',
          type: 'geo_shape',
          optional: false,
        },
      ],
      variadic: true,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'integer',
          optional: false,
        },
        {
          name: 'inlist',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: true,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'ip',
          optional: false,
        },
        {
          name: 'inlist',
          type: 'ip',
          optional: false,
        },
      ],
      variadic: true,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'inlist',
          type: 'keyword',
          optional: false,
        },
      ],
      variadic: true,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'inlist',
          type: 'text',
          optional: false,
        },
      ],
      variadic: true,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'long',
          optional: false,
        },
        {
          name: 'inlist',
          type: 'long',
          optional: false,
        },
      ],
      variadic: true,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'text',
          optional: false,
        },
        {
          name: 'inlist',
          type: 'keyword',
          optional: false,
        },
      ],
      variadic: true,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'text',
          optional: false,
        },
        {
          name: 'inlist',
          type: 'text',
          optional: false,
        },
      ],
      variadic: true,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'field',
          type: 'version',
          optional: false,
        },
        {
          name: 'inlist',
          type: 'version',
          optional: false,
        },
      ],
      variadic: true,
      returnType: 'boolean',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
